"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const operators_1 = require("../operators");
const class_1 = require("../class");
exports.logicExpression = ({ ast, execObject, }) => {
    const [literals, operators] = Object.keys(ast.children).map((rule) => {
        if (!operators_1.LogicalOperatorTokens.includes(rule)) {
            return ast.children[rule].map((x) => {
                return execObject.interpreter({ ast: x, execObject });
            });
        }
        else {
            return ast.children[rule].map((x) => x.image);
        }
    });
    // console.log(literals, operators);
    return literals.reduce((a, c, i) => {
        const name = c.name;
        return class_1.Classes[name][operators[i - 1]](c, a);
    });
};
